


















































import { computed, defineComponent, ref, toRefs, PropType } from '@vue/composition-api';
import { useLanguageMisMatch } from './../../ad-text/hooks';
import { AcoFormData, FullNormalFormData, PrecheckResult } from '@tt4b/ttam-enums';
import PrecheckPng from '@tt4b/ttam-assets/src/images/creative/precheck-new.png';
import AdaptiveListContainer from '@/components/common/adaptive-list-container/index.vue';

const name = 'ttam-creative-precheck-dialog';
export default defineComponent({
  name,
  components: { AdaptiveListContainer },
  props: {
    creativeData: {
      type: Object as PropType<FullNormalFormData & AcoFormData>,
      default: () => ({}),
    },
    precheckResult: {
      type: Object as PropType<PrecheckResult>,
      default: () => ({}),
    },
    isSubmiting: {
      type: Boolean,
      default: false,
    },
  },
  setup(props, { emit }) {
    const { precheckResult, creativeData } = toRefs(props);
    const { replaceDialogSuggestion } = useLanguageMisMatch({
      precheckResult,
      creativeData,
    });

    const precheckSummary = computed(() => precheckResult.value?.summaryResults || []);

    const handleIgnore = () => {
      emit('ignore');
    };

    const handleBack = () => {
      emit('back');
    };

    return { PrecheckPng, precheckSummary, handleIgnore, handleBack, replaceDialogSuggestion };
  },
});
